<template>
    <div>
        <HeadersWebsite header="จัดการภาพปกเว็บไซต์" :img_header="header_image" link_back="managewebsite"/>
        <ManageAbout/>
    </div>
</template>

<script>
    import HeaderImage from "@/assets/picture_1.png"
    import ManageAbout from "@/components/admin/manage_website/ManageAbout";
    import HeadersWebsite from "@/components/admin/manage_website/menu_website/HeadersWebsite";
    export default {
        name: "AboutPage",
        components: {
            HeadersWebsite,
            ManageAbout,
        },
        data() {
            return {
                header_image: HeaderImage
            }
        }
    }
</script>

<style scoped>

</style>
